import React from 'react'
import { Col, Form } from 'react-bootstrap'
import { connect } from 'formik'
import { useTranslation } from 'react-i18next'

const MspInfoField = ({ formik, canEdit, isAdmin = false, alignCenter = true, columnSize = 5 }) => {
  const { t } = useTranslation('common')
  return (
    <>
      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formSupportEmail"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>{t('Support_email')}</Form.Label>
        <Form.Control
          type="email"
          name="supportEmail"
          defaultValue={formik.values.supportEmail || formik.values?.mspInfo?.supportEmail}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.supportEmail}
          readOnly={!canEdit}
        />
        <Form.Control.Feedback type="invalid">{formik.errors.supportEmail}</Form.Control.Feedback>
      </Form.Group>
      <Form.Group
        as={Col}
        md={columnSize}
        controlId="formSupportPhoneNumber"
        className={alignCenter ? 'mx-auto' : ''}
      >
        <Form.Label>{t('Support_phone_number')}</Form.Label>
        <Form.Control
          type="text"
          name="supportPhone"
          defaultValue={formik.values.supportPhone || formik.values?.mspInfo?.supportPhone}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          isInvalid={!!formik.errors.supportPhone}
          readOnly={!canEdit}
          maxLength={30}
        />
        <Form.Control.Feedback type="invalid">{formik.errors.supportPhone}</Form.Control.Feedback>
      </Form.Group>
    </>
  )
}

export default connect(MspInfoField)
